import { BrowserRouter, Navigate, Route, Routes } from "react-router";

import { ThemeProvider } from "@providers/theme";
import MainLayout from "./layouts/main";
import { PortfolioPage } from "@pages/portfolio";
import "@mantine/core/styles.css";
import "@mantine/charts/styles.css";
import { MantineProvider } from "@mantine/core";
import { ReactQueryProvider } from "./providers/react-query";
import { WalletProvider } from "./providers/wallet";
import { Web3AuthProvider } from "@web3auth/modal-react-hooks";
import { web3AuthEthersContextConfig } from "@providers/auth";
import { TokenScreenerPage } from "./pages/token-screener";
// import { TokenPage as TokenPageV1 } from "./pages/token";
import { TokenPage as TokenPageV2 } from "./pages/token-v2";
// import { XScreenerPage } from "./pages/x-screener";
// import { XPostsPage } from "./pages/x-posts";
import { Toaster } from "react-hot-toast";
import { WalletScreener } from "./pages/wallet-screener";
// import Phase1Layout from "./layouts/phase-1-layout";
// import FramerIFrame from "./pages/framer-page/framer-i-frame";
import Web3AuthButtonInjector from "./features/header-phase-1/web3-auth-button-injector";
import { NotificationProvider } from "./providers/notifications-bot-actions/notifications-bot-actions";
import { CopyTrade } from "./pages/copy-trade";
import AdminLayout from "@layouts/admin";
import { AdminModalPage } from "@pages/admin";
import { Web3AuthOutsideClickCloser } from "./features/header-phase-1/web3-auth-outside-click-closer";
import RequireAdminAuth from "@pages/admin/require-admin-auth.tsx";
import TokenScreenerFilterProvider from "@providers/token-screener-filter/token-screener-filter-provider.tsx";
import TermsOfService from "./pages/terms-of-service";
import PrivacyPolicy from "./pages/privacy-policy";
import TradeSocketListener from "./features/trade-socket-listener";
import OrdersPage from "./pages/orders/orders-page";
import ErrorTest from "./pages/error-test";

function App() {
  return (
    <ThemeProvider>
      <ReactQueryProvider>
        <MantineProvider>
          <BrowserRouter>
            <NotificationProvider>
              <Web3AuthProvider config={web3AuthEthersContextConfig}>
                <Web3AuthButtonInjector />
                <Web3AuthOutsideClickCloser />
                <WalletProvider>
                  <TokenScreenerFilterProvider>
                    <TradeSocketListener />
                    <Routes>
                      <Route
                        path="/"
                        element={
                          <Navigate
                            to={{
                              pathname: "/screener",
                              search: new URLSearchParams(
                                window.location.search,
                              ).toString(),
                            }}
                            replace
                          />
                        }
                      />
                      {/* <Route path="/" element={<FramerIFrame />} />
                  <Route element={<Phase1Layout />}>
                    <Route path="/screener" element={<TokenScreenerPage />} />
                    <Route
                      path="/screener/:tokenId"
                      element={<TokenPageV2 />}
                    />
                  </Route> */}
                      <Route path="/" element={<MainLayout />}>
                        {/* <Route
                      path="/v2/"
                      element={<Navigate to="/screener" replace />}
                    /> */}
                        <Route path="/portfolio" element={<PortfolioPage />} />
                        <Route path="/orders" element={<OrdersPage />} />
                        <Route
                          path="/screener"
                          element={<TokenScreenerPage />}
                        />
                        <Route
                          path="/screener/:tokenId"
                          element={<TokenPageV2 />}
                        />
                        {/* <Route
                      path="/screener-v1/:tokenId"
                      element={<TokenPageV1 />}
                    /> */}
                        <Route
                          path="/wallet-screener"
                          element={<WalletScreener />}
                        />
                        <Route path="/copy-trade" element={<CopyTrade />} />
                        <Route
                          path="/legal/terms-of-service"
                          element={<TermsOfService />}
                        />
                        <Route
                          path="/legal/privacy-policy"
                          element={<PrivacyPolicy />}
                        />
                        {/* <Route path="/x-screener" element={<XScreenerPage />} />
                    <Route path="/x-screener/posts" element={<XPostsPage />} /> */}
                      </Route>
                      <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminModalPage />} />
                        <Route element={<RequireAdminAuth />}>
                          <Route
                            path="wallet-screener"
                            element={<WalletScreener />}
                          />
                        </Route>
                      </Route>
                      <Route path="/error-test" element={<ErrorTest />}></Route>
                    </Routes>
                  </TokenScreenerFilterProvider>
                </WalletProvider>
              </Web3AuthProvider>
            </NotificationProvider>
          </BrowserRouter>
        </MantineProvider>
        <Toaster
          position="top-center"
          containerStyle={{ inset: "0.625rem" }}
          toastOptions={{
            duration: 5000,
            style: {
              borderRadius: "10px",
              background: "#333",
              color: "#fff",
              zIndex: 9999,
            },
          }}
        />
      </ReactQueryProvider>
    </ThemeProvider>
  );
}

export default App;
